import { Instagram, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-panel/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <Logo />
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Whole-food first nutrition coaching for people with real health goals — zero unnecessary
              supplements, zero crash dieting.
            </p>
            <a
              href="https://www.instagram.com/fitness_fanatic_nik/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-btn"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full border border-gold/50 text-gold font-bold text-sm uppercase tracking-wide transition-all duration-300 hover:bg-gold hover:text-ink hover:shadow-glow-gold"
            >
              <Instagram className="h-4 w-4" />
              @fitness_fanatic_nik
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              {[
                { name: "About", href: "#about" },
                { name: "My Method", href: "#approach" },
                { name: "Services", href: "#services" },
                { name: "Sample Plan", href: "#sample-plan" },
                { name: "TDEE Calculator", href: "#tdee-calculator" },
                { name: "Client Transformations", href: "#transformations" },
                { name: "FAQ", href: "#faq" },
                { name: "Gallery", href: "/gallery" },
                { name: "Articles", href: "/blog" },
                { name: "Apply For Coaching", href: "#intake-form" },
              ].map((l) => (
                <li key={l.name}>
                  <a href={l.href} className="text-slate-400 transition-colors hover:text-emerald-400" data-testid={`footer-link-${l.name.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Programs</p>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>12-Week Body Transformation</li>
              <li>Custom Nutrition & Dietetics Blueprint</li>
              <li>Executive Lifestyle Protocol</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-line space-y-4">
          <p className="text-xs text-slate-500 leading-relaxed" data-testid="footer-disclaimer">
            <span className="font-semibold text-slate-400">Disclaimer:</span> Nikhil Shrirao is a Certified Dietitian
            &amp; Wellness Coach (National Health Care Academy), not a medical doctor. Coaching here is purely
            whole-food first — no commercial meal replacement shakes, synthetic MLM powders or blind fat burners are
            sold here, and any targeted
            supplementation is recommended only when a deep medical history or blood test markers demand it. The
            content on this website is general fitness and nutrition guidance only and does not constitute medical
            advice. If you are pregnant or breastfeeding, diabetic on insulin, on thyroid or blood-pressure
            medication, or managing kidney, liver or heart conditions, consult your physician before starting any
            plan.
          </p>
          <p className="text-xs text-slate-500 leading-relaxed" data-testid="footer-privacy">
            <span className="font-semibold text-slate-400">Privacy:</span> Details submitted through the application
            form are used solely for coaching assessment and are never shared with third parties.
          </p>
          <p className="text-xs text-slate-600 font-mono" data-testid="footer-copyright">
            © 2026 Nikhil Shrirao · Fitness Fanatic Nik. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}